import { render, staticRenderFns } from "./UserInterests.vue?vue&type=template&id=2dc9259e"
import script from "./UserInterests.js?vue&type=script&lang=js&external"
export * from "./UserInterests.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports